import { currentLang, pick } from "@kit/lang";

const STRINGS = {
  title: { tr: "Duvar", en: "Wall" },
  taps: { tr: "DOKUNUŞ", en: "TAPS" },
  status: { tr: "Resim %{pct} açık · {bumps} çarpma", en: "Picture {pct}% open · {bumps} bumps" },
  hint: { tr: "Blok okun yönünde kayar; önü kapalıysa çarpar. Basılı tutup çevir: aralardan bak.", en: "A block slides the way its arrow points; if something is in the way it bumps. Hold and drag to peek." },
  guess: { tr: "Tahmin et", en: "Guess" },
  giveUp: { tr: "Cevabı göster", en: "Show answer" },
  question: { tr: "Duvarın arkasında ne var?", en: "What is behind the wall?" },
  wrong: { tr: "Yanlış · +2 dokunuş", en: "Wrong · +2 taps" },
  repeat: { tr: "Bunu zaten denedin", en: "You already tried that" },
  correct: { tr: "Doğru!", en: "Correct!" },
  won: { tr: "Bildin!", en: "You got it!" },
  wonSub: { tr: "{taps} dokunuşta bildin · resmin %{pct}'i açıktı", en: "Solved in {taps} taps · {pct}% of the picture was open" },
  lost: { tr: "Cevap: {name}", en: "Answer: {name}" },
  lostSub: { tr: "Ceza yok. Tekrar dene, bu sefer daha az blokla.", en: "No penalty. Try again with fewer blocks." },
  skipHelp: { tr: "3 deneme oldu: istersen ücretsiz atla.", en: "Three tries: skip for free if you like." },
  retry: { tr: "Tekrar dene", en: "Try again" },
  skip: { tr: "Atla", en: "Skip" },
  share: { tr: "Paylaş", en: "Share" },
  shareText: { tr: "Duvar · Seviye {n}: {taps} dokunuşta bildim! Sen kaçta bilirsin?", en: "Wall · Level {n}: I got it in {taps} taps! Can you beat it?" },
  loading: { tr: "Yükleniyor…", en: "Loading…" },
  noWebgl: { tr: "Bu cihazda 3D açılamadı (WebGL yok).", en: "3D is not available on this device (no WebGL)." },
} as const;

export type Key = keyof typeof STRINGS;
export function t(key: Key, vars: Record<string, string | number> = {}): string {
  return pick(currentLang(), STRINGS[key]).replace(/\{(\w+)\}/g, (_m, k: string) => String(vars[k] ?? ""));
}
